import React from 'react'

const InputError = ({ children }) => {
  return <span className='d-block text-danger font-13 mb-1'>{children}</span>
}

export default InputError
